import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

interface ListDisplayFilterGroupLegendProps {
  disabled?: boolean;
  labelLegend: string;
  labelLegendId?: string;
  secondaryLabel?: string;
}

export const ListDisplayFilterGroupLegend = ({
  disabled,
  labelLegend,
  labelLegendId,
  secondaryLabel
}: ListDisplayFilterGroupLegendProps) => (
  <>
    <legend className="is-visually-hidden">{labelLegend}</legend>
    <UitkLayoutFlex space="two" className="uitk-type-heading-300">
      <>
        <UitkLayoutFlexItem grow={1}>
          <legend aria-hidden="true" id={labelLegendId && labelLegendId} className={disabled ? 'is-disabled' : null}>
            {labelLegend}
          </legend>
        </UitkLayoutFlexItem>
        {secondaryLabel && (
          <UitkLayoutFlexItem shrink={0}>
            <div aria-hidden="true" className={disabled ? 'is-disabled' : null}>
              {secondaryLabel}
            </div>
          </UitkLayoutFlexItem>
        )}
      </>
    </UitkLayoutFlex>
  </>
);
